var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"nav"},[_c('div',{staticClass:"user-name"},[_vm._v("\n        "+_vm._s(_vm.userName)+"\n    ")]),_vm._v(" "),(_vm.templateConfig.profile.navbar.share)?[_c('div',{staticClass:"share-btn",class:{ mirrorRotateLevel: _vm.$isRtl },on:{"click":_vm.handleShareClick}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }